import axiosRequest from "api";
import { payloadHelper } from "helpers/payload-helper";
import { ApiResponse } from "types/api";

import {
  AffiliateRegisterFormType,
  ChangePasswordFormType,
  ForgotPasswordFormType,
  LoginFormType,
  LoginResponse,
  RegisterFormType,
  RequestOTPType,
  VerifyTokenPayload
} from "./type";

export const AuthApi = {
  login: (typename: string, payload: LoginFormType) =>
    axiosRequest.post<LoginResponse>(
      "/",
      payloadHelper("MemberLogin", typename, payload)
    ),
  register: (typename: string, payload: RegisterFormType) =>
    axiosRequest.post<ApiResponse>(
      "/",
      payloadHelper("MemberRegister", typename, {
        ...payload,
        domain:
          window.location.hostname === "localhost"
            ? "agt91.99bb.net"
            : window.location.hostname
      })
    ),
  forgotPassword: (typename: string, payload: ForgotPasswordFormType) =>
    axiosRequest.post<ApiResponse>(
      "/",
      payloadHelper("ForgotPassword", typename, payload)
    ),
  async changePassword(typename: string, payload: ChangePasswordFormType) {
    const response = await axiosRequest.post<ApiResponse>(
      "/",
      payloadHelper("ChangePassword", typename, payload)
    );
    return response.data;
  },
  async verifyToken(typename: string, payload: VerifyTokenPayload) {
    const { data } = await axiosRequest.post<ApiResponse>(
      "/",
      payloadHelper("VerifyToken", typename, payload)
    );
    return data;
  },
  affiliateRegister: (payload: AffiliateRegisterFormType) =>
    axiosRequest.post<ApiResponse>(
      "/",
      payloadHelper("AgentRegister", payload.username, payload)
    ),
  requestOTP: async (payload: RequestOTPType) => {
    try {
      const res = await axiosRequest.post<ApiResponse>(
        "/",
        payloadHelper("RequestOTP", payload.username, payload)
      );
      return res.data;
    } catch (error) {
      throw new Error(error + "");
    }
  }
};
